import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import Index from '@/components/page/Index.vue';
import NotFound from '@/components/page/NotFound.vue';
import LaunchApp from '@/components/page/LaunchApp.vue';
import normalView from '@/components/layout/NormalView.vue';

Vue.use(VueRouter);

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: '',
    component: normalView,
    children: [
      {
        path: '/',
        name: 'Index',
        component: Index,
      }
    ]
  },
  {
    path: '/smartpost',
    name: 'Smartpost',
    component: Index
  },
  {
    path: '/xid',
    alias: ['/login', '/sign', '/jpki', '/jpkiUpdate'],
    name: 'LaunchApp',
    component: LaunchApp,
  },
  { path: "*", component: NotFound }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
